import { Component, OnInit } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';

import { NavigationService } from '../../../../../core/navigation.service';

import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { AlertService, ResourceService } from 'sce-core';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { SearchParams } from '../../../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../../../shared/search/models/search-status.model';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { Clause, Condition, SearchCriteria } from '../../../../../shared/search/models/search-filter-model';
import { CommodityDataService } from '../service/commodity-data.service';
import { PropertyChangeEvent, MANUAL_EDIT } from '../../../../../shared/models/property-change-event';

@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './commodity-skuInfo-accordian.component.html',
  styleUrls: ['./commodity-skuInfo-accordian.component.css']
})
export class CommoditySkuInfoAccordionComponent extends AbstractFormWidgetComponent implements OnInit {

  // LFWM-2761 - added packqtyIndicator(Detail Unit) field in SKU info accordion
  public accordionLine1: Array<any> = ['sku', 'innerPack', 'prepackIndicator', 'packqtyIndicator', 'hazardousFlag'];
  public accordionLine2: Array<any> = ['temperatureFlag', 'productModel', 'pressure', 'lottableCode'];

  public accordionLineExtended: Array<any> = [];
  public accordionLineExtendedDisplayNames: {} = {};

  public http$: HttpClient;
  public extendedFieldsMetadata;
  public extendedFieldsCellDataMap;

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService,
    protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry,
    public dataService: CommodityDataService) {
    super(resourceService, navService, leftPanelService,
      alertService, userService, dateConfigService);

    this.http$ = coreServiceRegistry.http$;

  }

  public ngOnInit() {
    super.ngOnInit();
   // below code added for LFWM-1904
    const storer = this.cellDataMap['storerKey'].cVal;
    // this.cellDataMap['storerKey'].cVal -- will give commodity level data
    this.getSpecialFieldList(storer).subscribe(res => {
      this.accordionLineExtended = [];
      // tslint:disable-next-line:forin
      // [LFWM-2911][To display the metadata received in UI]
      for (const key in res.columnTitles) {
        const value = res.columnTitles[key];
        const valueLowerCase = value['columnName'].toLowerCase();
        this.accordionLineExtended.push(valueLowerCase);
        this.accordionLineExtendedDisplayNames[valueLowerCase] = value['columnTitle'].toLowerCase();
      }
    });

    this.initializeSkuInfoExtendedSearchContext();
    // this.cellDataMap['sku'].cVal -- will give commodity level data
    this._getSkuInfoExtendedData(this.cellDataMap['sku'].cVal, storer);
  }

  /* Api call to get enabled extended field names and corresponding titles.
    c_ColName* - with 0/null/'' are ignored considering as disabled.
  */
  public getSpecialFieldList(storerKey: string): Observable<any> {
    const response$ = this.http$.get(`api/sku/title/` + storerKey)
      .map((response: any) => {
        /* const res = `{
            "statusCode": 200,
            "statusMessage": "SUCCESS",
            "columnTitles": {
                "c_ColName10": "0",
                "c_ColName11": "0",
                "c_ColName14": "0",
                "c_ColTitle10": "0",
                "c_ColName15": "0",
                "c_ColName12": "0",
                "c_ColName13": "0",
                "c_ColTitle13": "0",
                "c_ColName18": "0",
                "c_ColTitle14": "0",
                "c_ColName19": "0",
                "c_ColTitle11": "0",
                "c_ColName16": "extendedfield09",
                "c_ColTitle12": "0",
                "c_ColName17": "extendedfield08",
                "c_ColTitle17": "0",
                "c_ColTitle18": "0",
                "c_ColTitle15": "0",
                "c_ColTitle16": "0",
                "c_ColTitle19": "0",
                "c_ColName21": "extendedfield21",
                "c_ColName22": "extendedfield22",
                "c_ColName20": "extendedfield20",
                "c_ColName03": "extendedfield03",
                "c_ColTitle20": "MRP FOR MTH",
                "c_ColName04": "0",
                "c_ColTitle21": "GENERIC NAME",
                "c_ColName01": "extendedfield01",
                "c_ColName02": "extendedfield02",
                "c_ColTitle02": "PRODUCT CATEGORY",
                "c_ColName07": "0",
                "c_ColTitle03": "MRP",
                "c_ColName08": "0",
                "c_ColName05": "0",
                "c_ColTitle22": "PACKAGE CONTAINS",
                "c_ColTitle01": "HS CODE",
                "c_ColName06": "0",
                "c_ColTitle06": "0",
                "c_ColTitle07": "0",
                "c_ColTitle04": "0",
                "c_ColName09": "0",
                "c_ColTitle05": "0",
                "c_ColTitle08": "0",
                "c_ColTitle09": "0"
            }
          }`;
         return JSON.parse(res); */

        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  /* initialize the table and search context */
  public initializeSkuInfoExtendedSearchContext() {

    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = 'SKUINFOTD';
    searchParams.isFullFetch = true;
    // Client side pagination enabled
    searchParams.paginateLocally = true;
    const searchStatus: SearchStatus = new SearchStatus();
    this.dataService.skuInfoExtendedFieldsSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

    this.dataService.skuInfoExtendedFieldsSearchService.fetchMetadataOnly()
      .subscribe((response: any) => {
        this.extendedFieldsMetadata = {};
        response['columnList']
          .map((column: any) => {
            this.extendedFieldsMetadata[column.propertyName] = column;
          });
      });
  }



  private _getSkuInfoExtendedData(skuvalue: string, storerkey:string) {

    this.dataService.skuInfoExtendedFieldsSearchService.clearSearchStatus();
    /* set search criteria - condition*/
    const clause = new Clause();
    clause.operation = '=';
    clause.column = 'sku';
    clause.value = skuvalue;
    clause.logicalOperation = 'AND';
    const clause2 = new Clause();
    clause2.operation = '=';
    clause2.column = 'storerKey';
    clause2.value = storerkey;
    clause2.logicalOperation = 'AND';
    const searchCondition = new Condition();
    searchCondition.isMandatory = true;
    searchCondition.operator = 'OR';
    searchCondition.clauses = [clause, clause2];
    const searchCriteria = new SearchCriteria();
    searchCriteria.conditions.push(searchCondition);
    /* set search criteria - condition - end*/
    this.dataService.skuInfoExtendedFieldsSearchService.setSearchCriteria(searchCriteria);
    // this.dataService.skuInfoExtendedFieldsSearchService.performSearch();
    this.dataService.skuInfoExtendedFieldsSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        const pageRows = this.dataService.skuInfoExtendedFieldsSearchService.getPagedData().pageRows;
        this.extendedFieldsCellDataMap = pageRows.length > 0 ? pageRows[0].cells : null;
      });

  }

  // Method to return Cell Title corresponding to each property
  public getExtendedCellTitle(property: any): string {
    // return this.resourceService.get(this.extendedFieldsMetadata[property].elementId);
    // return the field display name as returned from sp
    return this.accordionLineExtendedDisplayNames[property];
  }

  /* method copied from super class.. nio overriding.
   and changed datamap for operating on extended fields datamap*/
  public valueChangedExtendedFields(key: any, sourceEvent?: any) {
    let newVal = null;
    if (sourceEvent !== null && sourceEvent !== undefined) {
      if ('string' === typeof sourceEvent) {
        newVal = sourceEvent;
      } else if ('object' === typeof sourceEvent) {
        newVal = sourceEvent['newVal'];
      }
    }

    if (newVal === null || newVal === undefined) {
      newVal = this.extendedFieldsCellDataMap[key].cVal;
    }

   //  this.cellDataMap[key].cValPrev = this.originalCellDataMap[key].cVal; // cVal prev is obtained from the original data
    // if the value has changed, send an event and check if the change can be accepted
    const event: PropertyChangeEvent = new PropertyChangeEvent();
    event.source = 'table-editor';
    event.type = MANUAL_EDIT;
    event.property = this.extendedFieldsCellDataMap[key].cName;
    event.value = newVal;
    // JIRA LFWM-1474 Fixes - current value and previous value of a dropdown element should not be the same value
    if (sourceEvent.type && sourceEvent.type === 'dropdown') {
      event.previousValue = sourceEvent.prevVal;
    } else {
      event.previousValue = this.extendedFieldsCellDataMap[key].cVal;
    }
    const acceptChange: boolean = this.dataEditor.propertyValueChanged(event);
    // if the property change is to be rejected, do not set the is edited flag
    if (acceptChange) {
      this.dataService.skuInfoExtendedFieldsSearchService.getPagedData().pageRows[0].isEdited = true;
      this.extendedFieldsCellDataMap[key].isEdited = true;
      this.navService.preventNavigation = true;
      // if the event is from dropdown the current value is already set in this.cellDataMap[key].cVal
      if (sourceEvent.type && sourceEvent.type === 'dropdown') {
        this.extendedFieldsCellDataMap[key].cValPrev = sourceEvent.prevVal;
      } else {
        this.extendedFieldsCellDataMap[key].cValPrev = this.extendedFieldsCellDataMap[key].cVal;
        this.extendedFieldsCellDataMap[key].cVal = newVal;
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/commodity/commodity-skuInfo-accordian/commodity-skuInfo-accordian.component.ts